export default __webpack_public_path__ + "static/media/modelo-de-alteração-contrato-para-sociedades-de-advogados.c8b151bb.docx";